<template>
    <section class="wrapper account-activation" data-qa="account-activation-page">
        <div class="account-activation__card">
            <figure class="account-activation__figure">
                <img src="@/assets/img/heart-hands.png" :alt="$t('signIn.registerSendAlt')" :title="$t('signIn.registerSendAlt')">
            </figure>

            <h1 class="account-activation__title">{{ $t('signIn.registerSendTitle') }}</h1>
            <p class="account-activation__intro">{{ $t('signIn.registerSendDesc') }}</p>

            <ol class="account-activation__steps">
                <li>{{ $t('signIn.registerStep1') }}</li>
                <li>{{ $t('signIn.registerStep2') }}</li>
                <li>{{ $t('signIn.registerStep3') }}</li>
            </ol>

            <div class="account-activation__notes">
                <p>{{ $t('signIn.registerNoteSpam') }}</p>
                <p>{{ $t('signIn.registerNoteExpiry') }}</p>
            </div>

            <AppButton data-qa="account-activation-home-button" to="/" variant="primary">{{ $t('signIn.registerHomeBtn') }}</AppButton>
        </div>
    </section>
</template>

<script>
import AppButton from '@/components/ui/AppButton.vue';
export default {
    components: {
        AppButton
    },

    created() {
        // SEO ======
        document.title = this.$t('meta.ativarConta.title');
        document.querySelector('meta[name="description"]').setAttribute('content', this.$t('meta.ativarConta.description'));
        document.querySelector('meta[name="keywords"]').setAttribute('content', this.$t('meta.ativarConta.keywords'));

        // Definindo as Meta Tags de Open Graph (og:*)
        document.querySelector('meta[property="og:title"]').setAttribute('content', this.$t('meta.ativarConta.title'));
        document.querySelector('meta[property="og:description"]').setAttribute('content', this.$t('meta.ativarConta.description'));
        // // Definindo as Meta Tags do Twitter
        document.querySelector('meta[name="twitter:title"]').setAttribute('content', this.$t('meta.ativarConta.title'));
        document.querySelector('meta[name="twitter:description"]').setAttribute('content', this.$t('meta.ativarConta.description'));
        // SEO ======

    },

}
</script>

<style lang="sass" scoped>
@use '../assets/sass/utilities/_responsive' as *
@use '../assets/sass/utilities/_mixin' as *

.account-activation
    flex-grow: 1
    display: flex
    justify-content: center
    align-items: flex-start
    padding-block: 3rem 4rem
    padding-inline: 1rem

    &__card
        width: min(100%, 34rem)
        margin-inline: auto
        display: flex
        flex-direction: column
        align-items: center
        text-align: center
        gap: 1.25rem
        padding: 2.5rem 2rem 3rem
        border-radius: 1.5rem
        background: var(--white)
        box-shadow: var(--shadow-default)

    &__figure
        margin: 0

        img
            display: block
            width: 11rem
            max-width: 55vw
            height: auto

    &__title
        margin: 0
        font-size: clamp(1.75rem, 5vw, 2.25rem)
        font-weight: 700
        text-wrap: balance
        color: var(--lg-dark-gray-200)

    &__intro
        margin: 0
        font-size: 1.0625rem
        font-weight: 500
        text-wrap: balance
        color: var(--lg-mid-gray-200)

    &__steps
        width: 100%
        max-width: 26rem
        margin: 0
        padding: 0
        list-style: none
        counter-reset: step
        display: flex
        flex-direction: column
        gap: 0.75rem
        text-align: left

        li
            counter-increment: step
            display: flex
            align-items: center
            gap: 0.875rem
            padding: 0.875rem 1rem
            border: 1px solid var(--lg-light-gray-300)
            border-radius: 0.875rem
            background: var(--lg-light-gray-100)
            font-size: 1rem
            color: var(--lg-dark-gray-200)

            &::before
                content: counter(step)
                display: inline-flex
                flex: 0 0 auto
                align-items: center
                justify-content: center
                width: 1.75rem
                height: 1.75rem
                border-radius: 50%
                font-size: 0.875rem
                font-weight: 600
                background: var(--lg-red-active)
                color: var(--white)

    &__notes
        display: flex
        flex-direction: column
        gap: 0.25rem

        p
            margin: 0
            font-size: 0.875rem
            line-height: 1.4
            color: var(--lg-mid-gray-200)

    +respond-to($sm-device-max)
        &__card
            padding: 2rem 1.25rem 2.5rem
</style>
